import type { DesignVersion } from '@fluentui-copilot/react-provider';
import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type ReferenceOverflowButtonSlots = {
  /** The root of the component that renders the overflow button. */
  root: Slot<'button'>;
};

/**
 * ReferenceOverflowButton Props
 */
export type ReferenceOverflowButtonProps = ComponentProps<ReferenceOverflowButtonSlots> &
  DesignVersion & {
    /**
     * The text that is displayed inside of the overflow button. This text is only displayed when `children` has not been passed to the component.
     * If a string is passed, that is what is rendered verbatim.
     * If a callback is passed, the callback is called with the number of items that are overflowing, and the result of the callback is rendered.
     */
    text?: string | ((overflowCount: number) => React.ReactNode);
  };

/**
 * State used in rendering ReferenceOverflowButton
 */
export type ReferenceOverflowButtonState = ComponentState<ReferenceOverflowButtonSlots> &
  Pick<Required<ReferenceOverflowButtonProps>, 'designVersion'> & {
    id: string;
    shouldRenderOverflowButton: boolean;
  };
